import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../../localization/react'
import {
  AdditionalPaymentMethodType,
  CustomPaymentMethodType,
  Mandate,
  PaymentMethodType,
  PaymentMethodVerificationMethod,
  StoredBankAccountWithMandates,
} from '../../typings/Payment'

import OnlineSepaForm from './OnlineSepaForm'
import PaypalPayLaterDisclaimer from './PaypalPayLaterDisclaimer'

interface Props {
  storedBankAccounts: Array<StoredBankAccountWithMandates>
  verifyWith: PaymentMethodVerificationMethod | null
  venueMandate: Mandate | null
  selectedPaymentMethodType: AdditionalPaymentMethodType
}

const PaymentMethodInformation = ({
  venueMandate,
  storedBankAccounts,
  verifyWith,
  selectedPaymentMethodType,
}: Props) => {
  switch (selectedPaymentMethodType) {
    case PaymentMethodType.PAYMENT_METHOD_PAYPAL:
      return (
        <Flex flexDirection="column" verticalSpacing="default">
          <PaypalPayLaterDisclaimer />
          <Text fontWeight="bold">
            <Localized id="pay-with" params={{ paymentMethodType: 'Paypal' }} />
          </Text>
          <Text>
            <Localized id="payment-method-information" params={{ paymentMethodType: 'Paypal' }} />
          </Text>
        </Flex>
      )
    case PaymentMethodType.PAYMENT_METHOD_BANCONTACT:
      return (
        <Flex flexDirection="column" verticalSpacing="default">
          <Text fontWeight="bold">
            <Localized id="pay-with" params={{ paymentMethodType: 'Bancontact' }} />
          </Text>
          <Text>
            <Localized id="payment-method-information" params={{ paymentMethodType: 'Bancontact' }} />
          </Text>
        </Flex>
      )
    case PaymentMethodType.PAYMENT_METHOD_TWINT:
      return (
        <Flex flexDirection="column" verticalSpacing="default">
          <Text fontWeight="bold">
            <Localized id="pay-with" params={{ paymentMethodType: 'TWINT' }} />
          </Text>
          <Text>
            <Localized id="payment-method-information" params={{ paymentMethodType: 'TWINT' }} />
          </Text>
        </Flex>
      )
    case PaymentMethodType.PAYMENT_METHOD_EPS:
      return (
        <Flex flexDirection="column" verticalSpacing="default">
          <Text fontWeight="bold">
            <Localized id="pay-with" params={{ paymentMethodType: 'eps Überweisung' }} />
          </Text>
          <Text>
            <Localized id="payment-method-information" params={{ paymentMethodType: 'eps Überweisung' }} />
          </Text>
        </Flex>
      )
    case PaymentMethodType.PAYMENT_METHOD_GIROPAY:
      return (
        <Flex flexDirection="column" verticalSpacing="default">
          <Text fontWeight="bold">
            <Localized id="pay-with" params={{ paymentMethodType: 'giropay' }} />
          </Text>
          <Text>
            <Localized id="payment-method-information" params={{ paymentMethodType: 'giropay' }} />
          </Text>
        </Flex>
      )
    case PaymentMethodType.PAYMENT_METHOD_SEPA_ONLINE:
      // We deal with the sepa online with ideal case as an ideal payment case on its own section
      if (verifyWith && verifyWith === PaymentMethodVerificationMethod.PAYMENT_METHOD_IDEAL && !venueMandate) {
        return null
      }
      return <OnlineSepaForm venueMandate={venueMandate} storedBankAccounts={storedBankAccounts} />
    case CustomPaymentMethodType.PAYMENT_METHOD_OFFLINE:
      return (
        <Flex flexDirection="column" verticalSpacing="default">
          <Text fontWeight="bold">
            <Localized id="pay-offline" />
          </Text>
          <Text>
            <Localized id="payment-method-offline-information" />
          </Text>
        </Flex>
      )
    default:
      return null
  }
}

export default React.memo(PaymentMethodInformation)
